import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexscreenerPoop = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Dexscreener Poop 💩 - Meme Token Reaction Service | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener Poop 💩 reactions! Perfect for meme tokens & ironic marketing. Starting $0.05/poop. Instant delivery, 20% bonus. The ultimate meme token reaction!" />
        <meta name="keywords" content="buy dexscreener poop, dexscreener poop, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener fire, dexreactions, poop dexscreener, dexscreener poop emoji, meme token dexscreener, buy poop reactions, cheap dexscreener poop" />
        <link rel="canonical" href="https://dexreaction.com/buy-dexscreener-poop" />
        <meta property="og:title" content="Buy Dexscreener Poop 💩 - Meme Token Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener Poop from $0.05! Perfect for meme tokens. Instant delivery, 20% bonus!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dexreaction.com/buy-dexscreener-poop" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-amber-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-amber-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Buy Poop Now
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-amber-500/20 text-amber-300 px-6 py-3 rounded-full font-semibold mb-6">
              💩 The Ultimate Meme Token Reaction
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6">
              <span className="bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-600 bg-clip-text text-transparent">
                Buy Dexscreener Poop
              </span>
            </h1>
            <div className="text-8xl mb-6">💩</div>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              The Iconic Meme Token Reaction
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Poop 💩 reactions are perfect for meme tokens, ironic marketing, and standing out with humor. Embrace the meme culture!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-700 hover:to-yellow-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                💩 Buy Dexscreener Poop
              </button>
              <button
                onClick={() => window.open('https://t.me/dexreactionrobot', '_blank')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all border border-amber-500/30"
              >
                Telegram Bot
              </button>
            </div>
          </div>
        </section>

        {/* Why Poop */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Buy Dexscreener Poop?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { icon: '😂', title: 'Meme Culture', desc: 'Poop 💩 is THE reaction for meme tokens. Embrace the humor and stand out from serious projects.' },
                { icon: '🎭', title: 'Ironic Marketing', desc: 'Use poop reactions ironically to create buzz and engagement. Sometimes bad is good!' },
                { icon: '👀', title: 'Attention Grabber', desc: 'High poop counts make your token listing memorable and shareable.' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-amber-900/30 to-yellow-900/30 border border-amber-500/20 rounded-xl p-6 text-center hover:border-amber-500/50 transition-all">
                  <div className="text-5xl mb-4">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Perfect For */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Poop 💩 is Perfect For
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { title: 'Meme Tokens', desc: 'The official reaction of meme coin culture' },
                { title: 'Ironic Marketing', desc: 'Create buzz with unconventional approach' },
                { title: 'Degen Projects', desc: 'Embrace the degen spirit fully' },
                { title: 'Fun Communities', desc: 'Show your community has humor' }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-amber-500/20 rounded-xl p-6 text-center">
                  <div className="text-4xl mb-3">💩</div>
                  <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Dexscreener Poop Pricing
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              $0.05 per poop reaction + 20% Bonus FREE
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600 },
                { qty: 1000, price: 50, total: 1200, popular: true },
                { qty: 1500, price: 75, total: 1800 },
                { qty: 2000, price: 100, total: 2400 }
              ].map((pkg) => (
                <div key={pkg.qty} className={`relative bg-gradient-to-br from-amber-900/30 to-yellow-900/30 border-2 ${pkg.popular ? 'border-amber-500' : 'border-amber-500/30'} rounded-xl p-6 hover:border-amber-500 transition-all`}>
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-amber-600 to-yellow-600 text-white px-4 py-1 rounded-full text-sm font-bold">Most Popular</span>
                    </div>
                  )}
                  <div className="text-center">
                    <div className="text-4xl mb-2">💩</div>
                    <div className="text-3xl font-bold mb-2">{pkg.qty}</div>
                    <div className="text-gray-400 mb-4">Poop Reactions</div>
                    <div className="text-4xl font-bold text-amber-400 mb-2">${pkg.price}</div>
                    <div className="bg-green-500/20 rounded-lg p-2 mb-4">
                      <span className="text-green-400 font-semibold">Get {pkg.total} total</span>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Buy Poop
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reaction Comparison */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Choose Your Reaction Style
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              {[
                { emoji: '🚀', name: 'Rocket', vibe: 'Bullish & Serious', link: '/buy-dexscreener-rockets' },
                { emoji: '🔥', name: 'Fire', vibe: 'Hot & Trending', link: '/buy-dexscreener-fire' },
                { emoji: '💩', name: 'Poop', vibe: 'Meme & Fun', link: '/buy-dexscreener-poop', active: true }
              ].map((item, idx) => (
                <div key={idx} className={`bg-slate-800/50 border-2 ${item.active ? 'border-amber-500' : 'border-slate-600'} rounded-xl p-6 text-center cursor-pointer hover:border-amber-500/50 transition-all`} onClick={() => navigate(item.link)}>
                  <div className="text-5xl mb-3">{item.emoji}</div>
                  <h3 className="text-xl font-bold mb-2">{item.name}</h3>
                  <p className="text-sm text-gray-400">{item.vibe}</p>
                  {item.active && (
                    <div className="mt-3">
                      <span className="bg-amber-500/20 text-amber-400 px-3 py-1 rounded-full text-xs font-semibold">You are here</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Dexscreener Poop FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'Is poop 💩 a negative reaction?', a: 'Not necessarily! In meme culture, poop is often used ironically and humorously. Many successful meme tokens embrace poop reactions as part of their brand.' },
                { q: 'Who should buy poop reactions?', a: 'Meme tokens, degen projects, and anyone who wants to stand out with humor. If your community appreciates meme culture, poop reactions can boost engagement.' },
                { q: 'Can I mix poop with rockets?', a: 'Absolutely! Many tokens use multiple reaction types. Poop + Rockets creates a unique impression and shows your community has both humor and bullish sentiment.' },
                { q: 'Are poop reactions delivered the same way?', a: 'Yes! Same delivery speed (500 per 10 minutes), same pricing ($0.05), same 20% bonus. Only the emoji is different!' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-amber-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2 text-amber-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Embrace the Meme! 💩
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Buy Dexscreener Poop and show your token has personality
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-700 hover:to-yellow-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              💩 Buy Dexscreener Poop Now
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-amber-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-amber-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-amber-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-amber-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexscreenerPoop;
